import { render } from "./FlashCard.vue?vue&type=template&id=0f2ca4ca&scoped=true"
import script from "./FlashCard.vue?vue&type=script&lang=js"
export * from "./FlashCard.vue?vue&type=script&lang=js"

import "./FlashCard.vue?vue&type=style&index=0&id=0f2ca4ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f2ca4ca"]])

export default __exports__